import { ethers } from "ethers";
import React, { Component } from "react";
import { getBuso126Contract, getBusoContract } from "../../services/contract";
import getContract from "../../services/contract";
import { Link } from 'react-router-dom';
import transactionTypes from '../../helpers/transactionType';
import withWrapper from '../../helpers/withWrapper';
import getWallet from '../../services/wallet';
import { TransactionService } from '../../services/transactionService';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Buso126 extends Component {
  state = {
    userId: 0,
    currentParrent: 0,
    childs:  new Array(2).fill(0),
    recycleCount: 0,
    latestRecycleCount: 0,
    isJoined: false,
    totalIds: 0,
    isDataFetched: false
  };
  constructor(props) {
    super(props);
    this.state.userId = props.router.params.id;
  }

  handleIdClick = async (userId) => {
    await this.setData(userId);
    this.props.router.navigate('/buso126/' + userId);
  }

  handleReinvestClick = async (userId, cycleId) => {
    await this.setData(userId, cycleId);
  }

  async componentDidMount() {
    const wallet = await getWallet();
    if(!wallet.isReadOnly) {
      const browserAddresses = await wallet.provider.listAccounts();
      this.setState({ signer: browserAddresses[0], isConnected: true });
      console.log("Wallet Connected");
    }
     const promise = this.setData(this.state.userId);
        

          await toast.promise(
            promise,
              {
                pending: 'Fetching Buso126 please wait...',
                success: 'Data Fetched! 👌',
                error: 'Error fetching data'
              }
          )
  }

  setData = async (userId, cycleNumber) => {
    const contract = await getContract();
    const busoContract = await getBusoContract();
    const buso126Contract = await getBuso126Contract();
    

    const userAddress = await contract.getAddressById(userId);

    const totalIds = ethers.BigNumber.from(await buso126Contract.buso126IdsCount()).toNumber();
    
    const isJoined = await buso126Contract.isBuso126Joined(userId);

    // const busoBalance = await busoContract.balanceOf(this.state.signer);

    if(isJoined) {
      const latestRecycleCount = ethers.BigNumber.from(await buso126Contract.userBuso126LastRecycleCount(userId)).toNumber();
      
      let recycleCount = latestRecycleCount;
      if(cycleNumber != undefined) {
        recycleCount = +cycleNumber;
      }
  
      const activeBuso126TreeInfoResponse = await buso126Contract.activeBuso126TreeInfo(userId);

      const currentParrent =  ethers.BigNumber.from(await buso126Contract.getBuso126CurrentParrent(userId, recycleCount)).toNumber();
      // console.log(currentParrent);
  
      // const currentParrent = ethers.BigNumber.from(activeBuso126TreeInfoResponse["currentParent"]).toNumber();
      
      const childsResponse = await buso126Contract.getBuso126Childs(userId, recycleCount);
  
      let childsArray = [];
      childsResponse.forEach((response, index) => {
        const id = ethers.BigNumber.from(response).toNumber();
        childsArray[index] = id;
      });
      
      this.setState({ childs: childsArray, recycleCount, latestRecycleCount, userAddress, userId, currentParrent, isJoined, totalIds, isDataFetched: true });

    } else {
      this.setState({ isJoined, totalIds, isDataFetched: true });
    }
  }

  connectWallet = async () => {
    const wallet = await getWallet();
    if(!wallet.isReadOnly) {
        // if(wallet.isWrongNetwork) {
        //     throw new Error('Switch to Polygon');
        //     return;
        // }
        const browserAddresses = await wallet.provider.listAccounts();
        this.setState({ signer: browserAddresses[0], isConnected: true });
    } else {
        throw new Error('Wallet not connected');
    }
  }

  handleRegister = async () => {
    await this.connectWallet();
    if(!this.state.isConnected) {
        alert('Connect wallet');
        return;
    }
    try {
        var transactionService = new TransactionService(this.state.userId, this.state.signer);
        const registrationPromise = transactionService.registerOnBuso126();
        const result = await toast.promise(
            registrationPromise,
            {
              pending: `Buso 126 Registeration in process`,
              success: 'Registration Successfull',
              error: 'Registration failed'
            },
        )
        if(result)
            this.setData(this.state.userId, 0);
    } catch (error) {
        alert(error);
    }
  }

  render() {
    return (
      <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
        <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
          <h1
            style={{
              fontSize: "60px",
              color: "#fbbd18",
              marginTop: "20px",
              marginBottom: "20px",
              textAlign: "center",
              fontWeight: "bold",
              textDecoration: "underline"
            }}
          >
            BUSO 126 Game
          </h1>
          
          
          {(!this.state.isJoined && this.state.isDataFetched) ? (
                  <div className="flex flex-1 flex-col items-start mr-10 sm:mr-0 sm:items-stretch sm:max-w-full sm:p-5 items-center">
                    <div className="flex flex-col sm:flex-1 ">
                      <span className="inline-block text-two-half text-white mb-10 sm:mb-7.5 sm:text-2xl">
                        Get 5600 BUSO By Just investing 1000
                      </span>

                      <div className="flex flex-col space-y-5 items-center">
                        <div className="flex flex-col items-start">
                          <div className="flex ">
                            <i className="las la-info-circle text-3xl text-base"></i>
                            <div
                              className="flex flex-wrap items-center ml-2.5 leading-5 text-base whitespace-nowrap"
                              id="regbalance"
                            >
                              <span style={{fontSize: "24px"}}>Total ids: {this.state.totalIds}</span>
                            </div>
                          </div>
                        </div>

                        <div className="flex flex-col items-start">
                          <div className="flex ">
                            <i className="las la-info-circle text-3xl text-base"></i>
                            <div
                              className="flex flex-wrap items-center ml-2.5 leading-5 text-base whitespace-nowrap"
                              id="regregistration"
                            >
                              <span style={{fontSize: "24px"}}>
                                Joining Fee: <strong>1000 BUSO </strong>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex">
                      <button
                        style={{ background: "white" }}
                        className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-4 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 mt-10 py-5 !px-10 sm:py-5 sm:mt-7.5"
                        onClick={this.handleRegister}
                        id="nextButton"
                      >
                        Register{" "}
                      </button>
                    </div>
                  </div>
              ) : (this.state.isDataFetched) ? (
                <div className="flex flex-col space-y-10 sm:space-y-7.5 z-0">
                  <div className="flex z-10 !mt-0">
                    <div className="flex flex-col w-full flex-wrap sm:px-5">
                      <div className="flex items-center mb-1.5 sm:mb-2.5"></div>
                      <div className="w-full flex justify-center flex-wrap">
                        <div className="flex items-center">
                          <span className="text-two-half text-white font-medium mr-2 sm:text-2xl whitespace-nowrap">
                            Current ID Recycle: {this.state.recycleCount}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a className="flex w-full items-center justify-center sm:px-5 z-10">
                    <button
                      onClick={() => this.handleIdClick(this.state.currentParrent)}
                      className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-black-light hover:bg-line-gray active:bg-active-gray !p-5 w-8/12 xl:w-full sm:!p-4 rounded font-normal"
                    >
                      <span className="text-white text-base !leading-30px sm:text-sm">
                        Upline
                      </span>
                      <span className="rounded bg-white-100 px-2.5 text-white text-base ml-2.5 !leading-30px sm:text-sm">
                        ID {this.state.currentParrent}
                      </span>
                    </button>
                  </a>
                  <div className="">
                    <div className="flex flex-col sm:px-5 space-y-10 z-10">
                      <div className="flex space-x-10 xl:space-x-0 z-10">


                        <div className="flex w-full min-h-340px sm:min-h-290px col-span-4 rounded relative  bg-gray-900 hover:bg-gray-800 ">
                          <div className="flex w-full flex-col z-10 p-7.5 sm:p-5">
                            <div className="flex w-full justify-between mb-7.5 z-10">
                              <div className="flex flex-1 items-start justify-start ">
                                <div className="flex items-center space-x-2.5">
                                  <span className="text-white-300 text-two-half font-normal sm:text-xl">
                                    {/* {this.state.recycleCount} */}
                                  </span>
                                </div>
                              </div>
                              <div className="flex-1 flex flex-col items-center">
                                <span className="text-white text-two-half font-medium mb-2.5 sm:text-xl">
                                  ID {this.state.userId}
                                </span>
                              </div>
                              <div className="flex items-start justify-end flex-1 text-white-300 text-two-half font-normal text-right  sm:text-xl"></div>
                            </div>
                            <div className="flex flex-col w-full h-full z-10">
                              <div className="flex justify-center mb-15 sm:mb-10">
                                <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                  {/* First tree */}
                                  <div className="flex flex-col justify-around items-center w-full">
                                    <a
                                      onClick={() =>
                                        this.handleIdClick(this.state.childs[0])
                                      }
                                    >
                                      <div className="relative">
                                        {!this.state.childs[0] ? (
                                          <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75"></div>
                                        ) : (
                                          <div className="flex flex-col rounded-full w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75 bg-orange">
                                            <span className="text-black text-base sm:text-sm">
                                              {this.state.childs[0]}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </a>
                                  </div>
                                  {/* Second tree */}
                                  <div className="flex flex-col justify-around items-center w-full">
                                    <a
                                      onClick={() =>
                                        this.handleIdClick(this.state.childs[1])
                                      }
                                    >
                                      <div className="relative">
                                        {!this.state.childs[1] ? (
                                          <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75"></div>
                                        ) : (
                                          <div className="flex flex-col rounded-full w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75 bg-orange">
                                            <span className="text-black text-base sm:text-sm">
                                              {this.state.childs[1]}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-between">
                                <div className="flex space-x-14 xl:space-x-8 sm:space-x-7.5">
                                  <div className="flex flex-col">
                                    <span className="text-white text-base sm:text-white-500 sm:text-sm">
                                      Cycles
                                    </span>
                                    <div className="flex items-center mt-2.5">
                                      <svg
                                        className="stroke-current text-white-500 w-6 h-6"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        stroke="#2CFF4E"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          clipRule="evenodd"
                                          d="M6.354 3.818a7.25 7.25 0 0 1 10.808 5.28.5.5 0 1 1-.99.137A6.25 6.25 0 0 0 4.551 7h2.115a.5.5 0 0 1 0 1H3.333a.5.5 0 0 1-.5-.5V4.167a.5.5 0 1 1 1 0v2.086a7.25 7.25 0 0 1 2.521-2.435ZM3.265 10.338a.5.5 0 0 1 .564.427A6.25 6.25 0 0 0 15.449 13h-2.116a.5.5 0 1 1 0-1H16.667a.5.5 0 0 1 .5.5v3.333a.5.5 0 1 1-1 0v-2.086a7.25 7.25 0 0 1-13.329-2.845.5.5 0 0 1 .427-.564Z"
                                        ></path>
                                      </svg>
                                      <span className="text-white text-base ml-2.5 sm:text-sm">
                                        {this.state.recycleCount+1}{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex absolute rounded -bottom-5 top-5 right-5 left-2.5 bg-opacity-50"></div>
                        </div>
                      </div>

                      <div className="hidden xl:flex justify-between">
                       
                      
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full items-center justify-center z-10 sm:px-5">
                    <div className="flex bg-black-light p-5 rounded w-full items-center justify-center w-8/12 xl:w-full">
                      <div className="flex items-center justify-center w-full">
                        {new Array(this.state.latestRecycleCount + 1)
                          .fill(1)
                          .map((val, index) => {
                            return (
                              <div key={index} className="relative mr-5">
                                <a
                                  className="text-white text-base sm:text-sm flex items-center justify-center cursor-pointer"
                                  onClick={() =>
                                    this.handleReinvestClick(
                                      this.state.userId,
                                      index
                                    )
                                  }
                                >
                                  <span className="mr-2">Cycle : {index+1}</span>
                                </a>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
          ) : (<></>)}
          
          <footer
            style={{ background: "#18191A" }}
            className="flex lg:flex-col items-center mt-auto justify-between lg:justify-start lg:items-start py-10 w-full lg:p-5 lg:pb-9 pb-0 lg:pb-0 z-10"
          >
            <div className="hidden lg:block mb-7.5">
              <div className="flex space-x-5 w-full">
                <a
                  className="w-6 h-6 sm:w-7 sm:h-7 flex justify-center items-center rounded-full bg-white-100 hover:bg-white-300"
                  target="_blank"
                  href="https://t.me/+juU7UyeaDNpmYzNk"
                >
                  <svg
                    className="w-3 h-3 sm:w-4 sm:h-4"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      clipRule="evenodd"
                      d="M11.915.776.841 5.168a.4.4 0 0 0 .03.755l2.79.864 1.133 3.503a.4.4 0 0 0 .653.17l1.64-1.523 3.11 2.29a.4.4 0 0 0 .627-.231l2.166-9.294a.8.8 0 0 0-1.075-.926Zm-6.483 6.74-.346 2.072-.8-2.901 7.816-5.1-6.67 5.929Z"
                      fill="#fff"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
            <div id="google_translate_element"></div>
            <span className="text-white-500 text-xs font-normal lg:mb-2.5">
              © 2022 All Rights Reserved
            </span>
          </footer>
        </div>
      </div>
    );
  }
}

export default withWrapper(Buso126);
